export default "__VITE_ASSET__CU5vyd0y__"